import Link from 'next/link';
import { useCallback, useState } from 'react';
import { IMenuItem } from '~/src/api/content/menu';
import * as ST from './styled';

interface IProps {
    item: IMenuItem;
    clickHandler?: () => void;
    onClick: (item: string) => void;
}

const Accordeon = ({ item, clickHandler, onClick }: IProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleHandler = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    return (
        <ST.AccordeonWrapper>
            <ST.Title
                isOpen={isOpen}
                isPromoted={!!item.promoted}
                onClick={toggleHandler}
            >
                {item.title}
                {!!item.promoted && (
                    <ST.PromoIcon />
                )}
            </ST.Title>
            <ST.Content
                isOpen={isOpen}
                withDesc={!!item.add_desc}
            >
                {item.add_desc && (
                    <ST.Description
                        dangerouslySetInnerHTML={{ __html: item.add_desc }}
                    />
                )}
                {item.children?.map(childItem => (
                    <ST.ChildItem key={childItem.id} onClick={clickHandler}>
                        <Link href={childItem.link} passHref>
                            <ST.ChildLink onClick={() => onClick(childItem.title)}>
                                {childItem.title}
                            </ST.ChildLink>
                        </Link>
                    </ST.ChildItem>
                ))}
            </ST.Content>
        </ST.AccordeonWrapper>
    );
};

export default Accordeon;
